import { ReportData } from '../types/reportTypes';

// January 2026 Sales Data - Standard Report (47 jobs from Sales CSV)
const jobData = [
  {
    jobInfo: "E-793: John Protzman",
    leadSource: "BBB",
    trade: "Windows & Doors",
    contractTotal: 24221.00,
    grossMarginPct: 0.4525,
    grossProfit: 10960.88,
    commissionPercentage: 4.00,
    salesCommission: 968.84,
    salesManagerFee: 242.21,
    companyOH: 3754.26,
    netProfit: 0
  },
  {
    jobInfo: "E-796: Shirley Richmond",
    leadSource: "Referral - From past customer",
    trade: "Windows & Doors",
    contractTotal: 9868.00,
    grossMarginPct: 0.5725,
    grossProfit: 5649.00,
    commissionPercentage: 7.00,
    salesCommission: 690.76,
    salesManagerFee: 98.68,
    companyOH: 1529.54,
    netProfit: 0
  },
  {
    jobInfo: "E-803: Jessica & Jared Anderson",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 5412.00,
    grossMarginPct: 0.4210,
    grossProfit: 2278.68,
    commissionPercentage: 4.00,
    salesCommission: 216.48,
    salesManagerFee: 54.12,
    companyOH: 838.86,
    netProfit: 0
  },
  {
    jobInfo: "E-787: MARC & JOY GORDON",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 24327.00,
    grossMarginPct: 0.4312,
    grossProfit: 10489.27,
    commissionPercentage: 4.00,
    salesCommission: 973.08,
    salesManagerFee: 243.27,
    companyOH: 3770.69,
    netProfit: 0
  },
  {
    jobInfo: "E-785: Bryan & Ashely Double",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 4155.00,
    grossMarginPct: 0.7357,
    grossProfit: 3057.00,
    commissionPercentage: 10.00,
    salesCommission: 415.50,
    salesManagerFee: 41.55,
    companyOH: 644.03,
    netProfit: 0
  },
  {
    jobInfo: "E-791: Mekonnen Merga",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 2632.90,
    grossMarginPct: 0.4284,
    grossProfit: 1127.91,
    commissionPercentage: 4.00,
    salesCommission: 105.32,
    salesManagerFee: 26.33,
    companyOH: 408.10,
    netProfit: 0
  },
  {
    jobInfo: "E-784: Christa & Dale Robinson",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 4582.00,
    grossMarginPct: 0.5354,
    grossProfit: 2453.29,
    commissionPercentage: 7.00,
    salesCommission: 320.74,
    salesManagerFee: 45.82,
    companyOH: 710.21,
    netProfit: 0
  },
  {
    jobInfo: "E-794: Steven & Shannon Menefee",
    leadSource: "Unknown",
    trade: "Gutters",
    contractTotal: 4775.00,
    grossMarginPct: 0.6214,
    grossProfit: 2967.25,
    commissionPercentage: 10.00,
    salesCommission: 477.50,
    salesManagerFee: 47.75,
    companyOH: 740.13,
    netProfit: 0
  },
  {
    jobInfo: "Mariel Galvan",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 8872.00,
    grossMarginPct: 0.4000,
    grossProfit: 3548.80,
    commissionPercentage: 4.00,
    salesCommission: 354.88,
    salesManagerFee: 88.72,
    companyOH: 1375.16,
    netProfit: 0
  },
  {
    jobInfo: "E-788: Joe & Laylnn Oberg",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 21843.00,
    grossMarginPct: 0.5681,
    grossProfit: 12408.44,
    commissionPercentage: 7.00,
    salesCommission: 1529.01,
    salesManagerFee: 218.43,
    companyOH: 3385.67,
    netProfit: 0
  },
  {
    jobInfo: "E-806: Kirklin Kudrna",
    leadSource: "Referral - Word of mouth",
    trade: "Roofing",
    contractTotal: 1950.00,
    grossMarginPct: 0.5240,
    grossProfit: 1021.75,
    commissionPercentage: 7.00,
    salesCommission: 136.50,
    salesManagerFee: 19.50,
    companyOH: 302.25,
    netProfit: 0
  },
  {
    jobInfo: "E-797: William & Carrie Brown",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 4848.00,
    grossMarginPct: 0.7078,
    grossProfit: 3431.20,
    commissionPercentage: 10.00,
    salesCommission: 484.80,
    salesManagerFee: 48.48,
    companyOH: 751.44,
    netProfit: 0
  },
  {
    jobInfo: "Jeffrey & SAUNDRA Wetzel Bishop",
    leadSource: "Previous Customer",
    trade: "Insulation",
    contractTotal: 27847.00,
    grossMarginPct: 0.4000,
    grossProfit: 11138.80,
    commissionPercentage: 4.00,
    salesCommission: 1113.88,
    salesManagerFee: 278.47,
    companyOH: 4316.29,
    netProfit: 0
  },
  {
    jobInfo: "E-805: Matt Toigo",
    leadSource: "Previous Customer",
    trade: "Gutters",
    contractTotal: 1480.00,
    grossMarginPct: 0.4223,
    grossProfit: 625.07,
    commissionPercentage: 4.00,
    salesCommission: 59.20,
    salesManagerFee: 14.80,
    companyOH: 229.40,
    netProfit: 0
  },
  {
    jobInfo: "E-819: Don & Laura Whittaker",
    leadSource: "Yelp",
    trade: "Siding",
    contractTotal: 12054.15,
    grossMarginPct: 0.6418,
    grossProfit: 7736.42,
    commissionPercentage: 10.00,
    salesCommission: 1205.42,
    salesManagerFee: 120.54,
    companyOH: 1868.39,
    netProfit: 0
  },
  {
    jobInfo: "E-807: Charles Pyatt",
    leadSource: "Angi",
    trade: "Windows & Doors",
    contractTotal: 3102.95,
    grossMarginPct: 0.4562,
    grossProfit: 1415.72,
    commissionPercentage: 4.00,
    salesCommission: 124.12,
    salesManagerFee: 31.03,
    companyOH: 480.96,
    netProfit: 0
  },
  {
    jobInfo: "Cyrus Tafti",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 2221.00,
    grossMarginPct: 0.4188,
    grossProfit: 930.25,
    commissionPercentage: 4.00,
    salesCommission: 88.84,
    salesManagerFee: 22.21,
    companyOH: 344.26,
    netProfit: 0
  },
  {
    jobInfo: "E-813: Robert & Rachel Cusmano",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 16486.00,
    grossMarginPct: 0.4422,
    grossProfit: 7290.72,
    commissionPercentage: 4.00,
    salesCommission: 659.44,
    salesManagerFee: 164.86,
    companyOH: 2555.33,
    netProfit: 0
  },
  {
    jobInfo: "E-816: Kevin & Shinduk Lynch Seo",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 6621.00,
    grossMarginPct: 0.4593,
    grossProfit: 3040.84,
    commissionPercentage: 4.00,
    salesCommission: 264.84,
    salesManagerFee: 66.21,
    companyOH: 1026.26,
    netProfit: 0
  },
  {
    jobInfo: "E-817: Marcia & Stacy Mouer Hunt",
    leadSource: "Events Division",
    trade: "Siding",
    contractTotal: 34620.25,
    grossMarginPct: 0.4559,
    grossProfit: 15784.30,
    commissionPercentage: 4.00,
    salesCommission: 1384.81,
    salesManagerFee: 346.20,
    companyOH: 5366.14,
    netProfit: 0
  },
  {
    jobInfo: "E-795: Jacky & Debra Loube",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 6188.00,
    grossMarginPct: 0.7592,
    grossProfit: 4698.00,
    commissionPercentage: 10.00,
    salesCommission: 618.80,
    salesManagerFee: 61.88,
    companyOH: 959.14,
    netProfit: 0
  },
  {
    jobInfo: "Vincent & Ruth Lee",
    leadSource: "Events Division",
    trade: "Windows & Doors",
    contractTotal: 24900.00,
    grossMarginPct: 0.4413,
    grossProfit: 10989.25,
    commissionPercentage: 4.00,
    salesCommission: 996.00,
    salesManagerFee: 249.00,
    companyOH: 3859.50,
    netProfit: 0
  },
  {
    jobInfo: "E-818: Michael & Saria Perro",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 7900.00,
    grossMarginPct: 0.5631,
    grossProfit: 4448.87,
    commissionPercentage: 7.00,
    salesCommission: 553.00,
    salesManagerFee: 79.00,
    companyOH: 1224.50,
    netProfit: 0
  },
  {
    jobInfo: "E-814: James Chatfield",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 9372.00,
    grossMarginPct: 0.4308,
    grossProfit: 4037.59,
    commissionPercentage: 4.00,
    salesCommission: 374.88,
    salesManagerFee: 93.72,
    companyOH: 1452.66,
    netProfit: 0
  },
  {
    jobInfo: "E-815: Chris & Kyra Detmer",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 37967.00,
    grossMarginPct: 0.5368,
    grossProfit: 20382.47,
    commissionPercentage: 7.00,
    salesCommission: 2657.69,
    salesManagerFee: 379.67,
    companyOH: 5884.89,
    netProfit: 0
  },
  {
    jobInfo: "E-839: Corey & Katy Misenheimer",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 25693.00,
    grossMarginPct: 0.4270,
    grossProfit: 10971.85,
    commissionPercentage: 4.00,
    salesCommission: 1027.72,
    salesManagerFee: 256.93,
    companyOH: 3982.42,
    netProfit: 0
  },
  {
    jobInfo: "E-810: Kenyon&Janelle Suggs",
    leadSource: "Events Division",
    trade: "Insulation",
    contractTotal: 2572.00,
    grossMarginPct: 0.5206,
    grossProfit: 1338.90,
    commissionPercentage: 7.00,
    salesCommission: 180.04,
    salesManagerFee: 25.72,
    companyOH: 398.66,
    netProfit: 0
  },
  {
    jobInfo: "E-838: Alicia & Fred Kenley",
    leadSource: "Events Division",
    trade: "Windows & Doors",
    contractTotal: 16721.00,
    grossMarginPct: 0.4359,
    grossProfit: 7288.82,
    commissionPercentage: 4.00,
    salesCommission: 668.84,
    salesManagerFee: 167.21,
    companyOH: 2591.76,
    netProfit: 0
  },
  {
    jobInfo: "Nancy Young",
    leadSource: "Events Division",
    trade: "Insulation",
    contractTotal: 3360.50,
    grossMarginPct: 0.6881,
    grossProfit: 2312.50,
    commissionPercentage: 10.00,
    salesCommission: 336.05,
    salesManagerFee: 33.61,
    companyOH: 520.88,
    netProfit: 0
  },
  {
    jobInfo: "E-829: Nancy Young",
    leadSource: "Events Division",
    trade: "Insulation",
    contractTotal: 3360.50,
    grossMarginPct: 0.6881,
    grossProfit: 2312.50,
    commissionPercentage: 10.00,
    salesCommission: 336.05,
    salesManagerFee: 33.61,
    companyOH: 520.88,
    netProfit: 0
  },
  {
    jobInfo: "Francesca & Anthony Reed",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 6973.00,
    grossMarginPct: 0.4163,
    grossProfit: 2902.76,
    commissionPercentage: 4.00,
    salesCommission: 278.92,
    salesManagerFee: 69.73,
    companyOH: 1080.82,
    netProfit: 0
  },
  {
    jobInfo: "Jessica & Marvin Huynh",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 3494.00,
    grossMarginPct: 0.3274,
    grossProfit: 1144.00,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 34.94,
    companyOH: 541.57,
    netProfit: 0
  },
  {
    jobInfo: "Devon & Brian Flanagan",
    leadSource: "Referral - Word of mouth",
    trade: "Windows & Doors",
    contractTotal: 4621.00,
    grossMarginPct: 0.4199,
    grossProfit: 1940.57,
    commissionPercentage: 4.00,
    salesCommission: 184.84,
    salesManagerFee: 46.21,
    companyOH: 716.26,
    netProfit: 0
  },
  {
    jobInfo: "Brett & Saranna Ramsay",
    leadSource: "Events Division",
    trade: "Windows & Doors",
    contractTotal: 16500.00,
    grossMarginPct: 0.4000,
    grossProfit: 6600.00,
    commissionPercentage: 4.00,
    salesCommission: 660.00,
    salesManagerFee: 165.00,
    companyOH: 2557.50,
    netProfit: 0
  },
  {
    jobInfo: "Adrian & JILLIAN Donnelly",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 8600.00,
    grossMarginPct: 0.4874,
    grossProfit: 4191.57,
    commissionPercentage: 4.00,
    salesCommission: 344.00,
    salesManagerFee: 86.00,
    companyOH: 1333.00,
    netProfit: 0
  },
  {
    jobInfo: "E-834: John O\u00b4Keefe",
    leadSource: "Referral - Word of mouth",
    trade: "Windows & Doors",
    contractTotal: 12772.00,
    grossMarginPct: 0.4000,
    grossProfit: 5108.80,
    commissionPercentage: 4.00,
    salesCommission: 510.88,
    salesManagerFee: 127.72,
    companyOH: 1979.66,
    netProfit: 0
  },
  {
    jobInfo: "E-824: George Tyree",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 3872.00,
    grossMarginPct: 0.6539,
    grossProfit: 2532.00,
    commissionPercentage: 10.00,
    salesCommission: 387.20,
    salesManagerFee: 38.72,
    companyOH: 600.16,
    netProfit: 0
  },
  {
    jobInfo: "E-833: Adrienne Gaither",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 7872.00,
    grossMarginPct: 0.5297,
    grossProfit: 4170.01,
    commissionPercentage: 7.00,
    salesCommission: 551.04,
    salesManagerFee: 78.72,
    companyOH: 1220.16,
    netProfit: 0
  },
  {
    jobInfo: "Jessica Wright",
    leadSource: "Porch",
    trade: "Windows & Doors",
    contractTotal: 20472.00,
    grossMarginPct: 0.4000,
    grossProfit: 8188.80,
    commissionPercentage: 4.00,
    salesCommission: 818.88,
    salesManagerFee: 204.72,
    companyOH: 3173.16,
    netProfit: 0
  },
  {
    jobInfo: "Sharon Lucas",
    leadSource: "Events Division",
    trade: "Roofing",
    contractTotal: 10972.00,
    grossMarginPct: 0.2543,
    grossProfit: 2789.77,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 109.72,
    companyOH: 1700.66,
    netProfit: 0
  },
  {
    jobInfo: "E-836: Christian Sifuentes",
    leadSource: "Google Paid Search",
    trade: "Roofing",
    contractTotal: 8600.00,
    grossMarginPct: 0.6449,
    grossProfit: 5546.46,
    commissionPercentage: 10.00,
    salesCommission: 860.00,
    salesManagerFee: 86.00,
    companyOH: 1333.00,
    netProfit: 0
  },
  {
    jobInfo: "Andrew & Emily Brodhead",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 19200.00,
    grossMarginPct: 0.4814,
    grossProfit: 9243.35,
    commissionPercentage: 4.00,
    salesCommission: 768.00,
    salesManagerFee: 192.00,
    companyOH: 2976.00,
    netProfit: 0
  },
  {
    jobInfo: "Nick & Leonora Cannon",
    leadSource: "Google Paid Search",
    trade: "Siding",
    contractTotal: 3772.00,
    grossMarginPct: 0.4000,
    grossProfit: 1508.80,
    commissionPercentage: 4.00,
    salesCommission: 150.88,
    salesManagerFee: 37.72,
    companyOH: 584.66,
    netProfit: 0
  },
  {
    jobInfo: "Trivens & Zainah Kargbo",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 3221.00,
    grossMarginPct: 0.5312,
    grossProfit: 1711.00,
    commissionPercentage: 7.00,
    salesCommission: 225.47,
    salesManagerFee: 32.21,
    companyOH: 499.26,
    netProfit: 0
  },
  {
    jobInfo: "Julie & Joseph DeBoer",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 7772.00,
    grossMarginPct: 0.4205,
    grossProfit: 3268.42,
    commissionPercentage: 4.00,
    salesCommission: 310.88,
    salesManagerFee: 77.72,
    companyOH: 1204.66,
    netProfit: 0
  },
  {
    jobInfo: "Omar Forrester",
    leadSource: "Events Division",
    trade: "Insulation",
    contractTotal: 2972.00,
    grossMarginPct: 0.7342,
    grossProfit: 2182.00,
    commissionPercentage: 10.00,
    salesCommission: 297.20,
    salesManagerFee: 29.72,
    companyOH: 460.66,
    netProfit: 0
  },
  {
    jobInfo: "Josh & Luna Zaritsky",
    leadSource: "Google Organic Search",
    trade: "Insulation",
    contractTotal: 27542.00,
    grossMarginPct: 0.4000,
    grossProfit: 11016.80,
    commissionPercentage: 4.00,
    salesCommission: 1101.68,
    salesManagerFee: 275.42,
    companyOH: 4269.01,
    netProfit: 0
  }
];

// Apply business logic to calculate net profit (Standard Report formula)
jobData.forEach(job => {
  // For Standard Reports: Net Profit = Gross Profit - (Sales Commission + Sales Manager Fee + Company OH)
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);
const totalManagerFees = jobData.reduce((sum, job) => sum + job.salesManagerFee, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);

// Ad spend data from January 2026 CSV
const adSpendData = [
  { source: "Networx", spend: 1058.96 },
  { source: "Thumbtack", spend: 9184.95 },
  { source: "Yelp", spend: 12330.00 },
  { source: "Porch", spend: 2661.36 },
  { source: "Web to Lead Form", spend: 4775.00 },
  { source: "Angi", spend: 2548.64 },
  { source: "Homebuddy", spend: 0.00 },
  { source: "RoofHero", spend: 1915.00 },
  { source: "Buyerlink", spend: 0.00 },
  { source: "Lead2performance", spend: 0.00 },
  { source: "Contractors Appointments", spend: 0.00 },
  { source: "Google Organic Search", spend: 3500.00 },
  { source: "Google Paid Search", spend: 9059.36 },
  { source: "Facebook / Meta Ads", spend: 2709.27 },
  { source: "Missed Call", spend: 0.00 },
  { source: "Previous Customer", spend: 0.00 },
  { source: "Other", spend: 0.00 },
  { source: "Blank", spend: 0.00 },
  { source: "Truck", spend: 0.00 },
  { source: "Referral - From past customer", spend: 0.00 },
  { source: "DataDump GoHighLevel", spend: 0.00 },
  { source: "Referral - Word of mouth", spend: 0.00 },
  { source: "Email Campaign", spend: 0.00 },
  { source: "SpringConnect - Call Center", spend: 0.00 },
  { source: "BBB", spend: 300.00 },
  { source: "Events Division", spend: 11500.00 },
  { source: "Self Generated Lead (By Rep)", spend: 0.00 },
  { source: "Yard Sign", spend: 0.00 },
  { source: "ROI Sales Portal", spend: 0.00 },
  { source: "Modernize", spend: 0.00 },
  { source: "33 Mile Radius / Everconnect", spend: 1400.00 },
  { source: "eLocal", spend: 2000.00 }
];

const totalAdSpend = adSpendData.reduce((sum, item) => sum + item.spend, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

// Create the final report data object
export const january2026Data: ReportData = {
  kpis: {
    // Total ad spend
    adSpend: totalAdSpend,

    // Sum of all contract totals
    totalSales: totalContractValue,

    // Sum of all gross profits
    grossProfit: totalGrossProfit,

    // Sum of all sales commissions
    salesCommissions: totalSalesCommissions,

    // Sum of all manager fees
    managerFees: totalManagerFees,

    // Company overhead
    companyOH: totalCompanyOH,

    // Net profit (standard calculation) minus ad spend
    netProfit: totalNetProfit - totalAdSpend,

    // Net profit as percentage of total sales
    netProfitPercent: (totalNetProfit - totalAdSpend) / totalContractValue,

    // Gross profit as percentage of total sales
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  // Ad spend by source with all sources
  adSpendBySource: adSpendData,

  // Sales by lead source - aggregated above
  salesBySource: salesBySource,

  // Sales by trade - aggregated above
  salesByTrade: salesByTrade,

  // Individual job data
  jobData: jobData,

  // Report period information
  period: {
    month: 1, // January
    year: 2026
  }
};
